import { AppConfigService } from 'features/app-config/services';
import type { RootState } from 'features/app/store/store';
import { selectNumberOfConsecutiveAnswerTimeouts } from 'features/session/store';

/**
 * Determines if the session should be finished based on consecutive answer timeouts
 * @param getState - Redux getState function
 * @param _dispatch - Redux dispatch function (reserved for future use)
 * @returns boolean - true if session should be finished
 */
export const checkShouldFinishSession = (
  getState: () => any,
  _dispatch: any
): boolean => {
  const state = getState() as RootState;
  const consecutiveAnswerTimeouts =
    selectNumberOfConsecutiveAnswerTimeouts(state);
  const threshold = AppConfigService.maxConsecutiveAnswerTO;

  return consecutiveAnswerTimeouts >= threshold;
};
